import { render, staticRenderFns } from "./oauth_redirect.vue?vue&type=template&id=4aa69524"
import script from "./oauth_redirect.vue?vue&type=script&lang=js"
export * from "./oauth_redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports